import { isFeatureEnabled } from "config/feature-flags"
import { isNotEmpty } from "helpers/objects"

const FILTERS_VALIDATION_FEATURE_FLAG_ID = "filtersValidations"

export function hasValidFilters(
	filters: Record<string, string | undefined>,
	keys?: Array<string>
): boolean {
	if (!isFeatureEnabled(FILTERS_VALIDATION_FEATURE_FLAG_ID)) return true

	const filtersValues = Object.values(filters)
	const filtersKeys = Object.keys(filters)
	let filtersToValidate: Record<string, string | undefined> = {}

	if (keys) {
		keys.map((key: string) => {
			const keyIndex = filtersKeys.indexOf(key)

			filtersToValidate = {
				...filtersToValidate,
				...{ [key]: filtersValues[keyIndex] },
			}
		})
	} else {
		filtersToValidate = filters
	}

	const validFilters = Object.values(filtersToValidate).every((filter) => {
		return isNotEmpty(filter)
	})
	return validFilters
}
